import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-link-area',
  templateUrl: './footer-link-area.component.html'
})
export class FooterLinkAreaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/footer-link-area/footer-link-area.component.ts